import { FC } from 'react';
import { ClothesFinderMainContentStoryblok } from 'storyblok-types';
import { components } from 'pages/StoryBlok/component';
import { IServerProps } from 'pages/StoryBlok/types';

export const ClothesFinderMainContent: FC<{
  blok: ClothesFinderMainContentStoryblok;
  serverProps?: IServerProps;
}> = ({ blok }) => {
  return blok?.content?.map((blok) => {
    const Component = (components?.[blok.component] as any) || null;

    return !Component ? null : <Component key={blok._uid} blok={blok} />;
  });
};
